// SaveToLibraryDialog — prompts the user for a name and POSTs to
// /library-templates/ to save an existing ItemQuote into their personal library.
//
// Opened from the new "Copy to lib" column in quotes.js. Closes on Cancel or
// after a successful Save. Dispatches 'library-templates-updated' so anything
// listening (e.g. the AddItem picker) refreshes immediately.

import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button,
} from '@mui/material';
import { authFetchRequest } from '../../utils/api';

const SaveToLibraryDialog = ({ open, sourceItemId, onClose, onSaved }) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  // Reset every time the dialog opens (per design: empty default).
  useEffect(() => { if (open) setName(''); }, [open]);

  const canSave = name.trim().length > 0 && !!sourceItemId && !saving;

  const handleSave = async () => {
    if (!canSave) return;
    setSaving(true);
    try {
      await authFetchRequest(
        '/library-templates/',
        { name: name.trim(), source_itemquote_id: sourceItemId },
        'POST',
      );
      window.dispatchEvent(new Event('library-templates-updated'));
      if (onSaved) onSaved();
      onClose();
    } catch (err) {
      console.error('Save to library failed:', err);
      alert('Failed to save to library: ' + (err?.message || 'unknown error'));
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Save to my library</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label="Template name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && canSave) handleSave(); }}
          placeholder="e.g. Standard 3-panel window"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!canSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveToLibraryDialog;
